import { render } from "./Bills.vue?vue&type=template&id=1bf2cd0c&scoped=true"
import script from "./Bills.vue?vue&type=script&lang=js"
export * from "./Bills.vue?vue&type=script&lang=js"

import "./Bills.vue?vue&type=style&index=0&id=1bf2cd0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf2cd0c"]])

export default __exports__